import { createContext, useState } from "react";

export default function useNavigation({ mainCtx, mainRouter, licensesDoc }) {
  const toOfficeSelect = () => {
    mainRouter.push("/offices");
  };

  const toPatientSignIn = officeId => {
    licensesDoc.subscribe(officeId);
    mainRouter.push("/licenses");
  };

  const toMainApp = officeId => {
    mainRouter.push("/checkout");
  };

  const toSignIn = () => {
    mainCtx.setOfficeId(null);

    mainRouter.push("/signin");
  };

  return {
    toOfficeSelect,
    toPatientSignIn,
    toSignIn,
    toMainApp
  };
}
